var _style, _path, _circle, _path2, _circle2, _path3, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    width: 800,
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .st0{fill:#000}\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.764 98.011c27.058 0 49.002-21.943 49.002-49.009C194.766 21.935 172.822 0 145.764 0c-27.066 0-49.009 21.935-49.009 49.002 0 27.066 21.943 49.009 49.009 49.009"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 110.089,
    cy: 377.876,
    r: 48.646
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.321 450.209c-33.874-.248-61.543 27-61.799 60.874l122.673.917c.247-33.874-27-61.534-60.874-61.791"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 271.065,
    cy: 377.876,
    r: 48.646
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.288 450.209c-33.866-.248-61.544 27-61.792 60.874L332.17 512c.248-33.874-27.008-61.534-60.882-61.791"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 432.033,
    cy: 377.876,
    r: 48.646
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.255 450.209c-33.866-.248-61.535 27-61.782 60.874l122.665.917c.255-33.874-27.009-61.534-60.883-61.791M272.66 235.671h-53.513v-39.657c.264-35.212-24.332-64.79-57.363-72.143l-6.089 18.87h-19.87l-6.072-18.837c-32.602 7.287-57.115 36.187-57.371 71.011v40.756H18.861v33.635H272.66zm-136.835-82.074h19.87v61.114l-9.932 8.592-9.939-8.592z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenClass);
export default __webpack_public_path__ + "static/media/openClass.672ee7535f93f006d9757428424a17b8.svg";
export { ForwardRef as ReactComponent };